"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckFileAccessApi = void 0;
const runtime = require("../runtime");
/**
 * no description
 */
class CheckFileAccessApi extends runtime.BaseAPI {
    /**
     * Check if file has been shared with me
     */
    canAccessFileRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.fileUuid === null || requestParameters.fileUuid === undefined)) {
                throw new runtime.RequiredError('fileUuid', 'Required parameter requestParameters.fileUuid was null or undefined when calling canAccessFile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/access/file/{fileUuid}`.replace(`{${"fileUuid"}}`, encodeURIComponent(String(requestParameters.fileUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Check if file has been shared with me
     */
    canAccessFile(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.canAccessFileRaw(requestParameters);
        });
    }
}
exports.CheckFileAccessApi = CheckFileAccessApi;
